/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'
import LocalDate from '../../domain/type/Date'

const MonthlyClosingSearchState = Record({
  search_monthly_close_date: LocalDate.today().beginningOfMonth(),
  search_hotel_ids: []
})

class MonthlyClosingHeadStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MonthlyClosingSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.monthChanged:
        return state.set('search_monthly_close_date', payload.date)

      default:
        return state
    }
  }
}

export default new MonthlyClosingHeadStore()
